import { useEffect, useRef, useState } from "react"
import styles from './cssModules/index.module.css';
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import Spinner from 'react-bootstrap/Spinner';

// ENV variable import to get URL
const apiURL = process.env.REACT_APP_SELLER;

export default function SellerSignup({ loginStatus, username }) {

    const [phone, SetNumber] = useState();
    const [mail, SetmailId] = useState('');
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [store, setstore] = useState('');
    const [address, setAddress] = useState('');
    const [pin, setPin] = useState('');
    const [b_address, setb_address] = useState('');
    const [b_address_pin, setb_address_pin] = useState('');
    const [b_city, setb_city] = useState('');
    const [b_state, setb_state] = useState('');
    const [gstin, setgstin] = useState('');
    const [bankAccNo, setbankAccNo] = useState('');
    const [payeeName, setpayeeName] = useState('');
    // const [ifsc, setifsc] = useState('');
    // const [otp, setOtp] = useState(0);

    const [phoneVerified, setPhoneVerified] = useState(false);
    const [mailVerified, setMailVerified] = useState(false);
    const [state, setState] = useState({
        otp: 0, // OTP button Display none (0)/ inline (1) This helps OTP button to be displayed or hide
        title: 0, // Title Phone number (0)/ Mail id (1) / fname (2) / lname (3) / store (4)/ address (5)/ pin (6)/ b_address (7)/ b_address_pin (8)/ gstin(9)/ bankAcc(10)/ payeeName (11)/ ifsc (12)
        resend: 0 // Change of Request (0)/ Resend (1)/ Continue (2)/ Save (3) of OTP button
    });
    const input_otp = useRef(null);
    const input_user = useRef(null);
    const navigate = useNavigate();

    // const [incorrectOTPModal, setIncorrectOTPModal] = useState(false);
    // const [phnExistModal, setPhnExistModal] = useState(false);
    // const [mailExistModal, setMailExistModal] = useState(false);
    // const [errorOccModal, setErrorOccModal] = useState(false);
    const [showIncorrectOTPMsg, setshowIncorrectOTPMsg] = useState(false);
    const [resendDisable, setResendDisable] = useState(false);
    const [renendGap, setResendGap] = useState(0);
    const [showResend, setResend] = useState(false);

    const resendIntervalRef = useRef(null); // Reference for setInterval
    const resendTimeoutRef = useRef(null); // Reference for setTimeout

    const [validateDisabled, setvalidateDisabled] = useState(false);

    const [confirmation, setConfirmation] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let response = await fetch(`${apiURL}/api/loginCheck`, {
                    method: 'GET',
                    headers: { 'Content-type': 'Application/json' },
                    credentials: "include"
                })
                if (response.status === 500) {
                    throw new Error('Login api error');
                } else {
                    if (response.status === 200) {
                        navigate('/');
                    }
                }
            } catch (error) {
                navigate('/error');
                console.log(error.message);
            }
        }

        fetchData();
    }, [navigate]);

    // This function works on the input of users, whenever a user gives some input, this gets triggered
    let inputCheck = function (e) { // On change event
        if (state.title === 0) { // When user input has 10 char and title is phone number then execute the next block
            if (e.target.value.length === 10) {
                setState((values) => {
                    return { ...values, otp: 1 } // Make OTP = 1 means, display OTP request button
                });
            } else {
                setState((values) => {
                    return { ...values, otp: 0 } // Make OTP = 0 means, close OTP request button
                });
            }
        } else if (state.title >= 1) { // When phone number verification is done; Title is mailID
            setState((values) => {
                return { ...values, otp: 1, resend: 3 } // OTP = 1 means, display OTP request button, resend = 3 means show "Save"
            });
        }
        // else if (state.title >= 2) { // When phone number verification is done; Title is mailID
        //     setState((values) => {
        //         return { ...values, otp: 1, resend: 3 } // OTP = 1 means, display OTP request button, resend = 3 means show "Save"
        //     });
        // }
    }

    const setupRecaptcha = () => {
        // Check if container exists in DOM
        const containerExists = document.getElementById('recaptcha-container');
        if (!containerExists) {
            console.error('recaptcha-container div is missing from the DOM!');
            return;
        }

        // Only create verifier if not already present
        if (!window.recaptchaVerifier) {
            try {
                window.recaptchaVerifier = new RecaptchaVerifier(auth,
                    'recaptcha-container',
                    {
                        'size': 'invisible',
                        'callback': () => {
                            console.log("reCAPTCHA verified");
                        },
                        'expired-callback': () => {
                            window.location.reload();
                        }

                    }
                );

                window.recaptchaVerifier.render().then(widgetId => {
                    window.recaptchaWidgetId = widgetId;
                });
            } catch (error) {
                console.error("Failed to initialize reCAPTCHA:", error);
            }
        } else {
            console.log("reCAPTCHA already initialized.");
        }
    };

    // This function will help user to send/ resend the OTP
    async function requestOtp(e) {
        try {
            e.preventDefault();
            setShowSpinner(true);
            // Firebase OTP
            if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
            }

            setupRecaptcha();

            const appVerifier = window.recaptchaVerifier;
            let phone = `+91${input_user.current.value}`;

            try {
                setvalidateDisabled(true);
                const confirmationResult = await signInWithPhoneNumber(auth, phone, appVerifier);
                setConfirmation(confirmationResult);
                alert('OTP sent');
                setShowSpinner(false);
                setvalidateDisabled(false);
            } catch (error) {
                setvalidateDisabled(false);
                console.error("SMS not sent", error);
                console.log('Error from line no 110');
            }
            input_otp.current.style.display = 'inline' // Display OTP input box
            setResendDisable(true);
            setState((values) => {
                return ({ ...values, resend: 2 }) // request 1 means, display validate msg
            });

            // Clear any existing timers
            if (resendIntervalRef.current) clearInterval(resendIntervalRef.current);
            if (resendTimeoutRef.current) clearTimeout(resendTimeoutRef.current);

            setResendGap(30);

            // Start the interval to update the timer
            resendIntervalRef.current = setInterval(() => {
                setResendGap((prevGap) => {
                    if (prevGap <= 1) {
                        clearInterval(resendIntervalRef.current); // Stop interval
                        return 0;
                    }
                    return prevGap - 1;
                });
            }, 1000);

            // Set a timeout to re-enable resend button
            resendTimeoutRef.current = setTimeout(() => {
                setResendDisable(false); // Enable resend button
                clearInterval(resendIntervalRef.current); // Clear interval just in case
            }, 30000);

            input_user.current.disabled = true;

            setResend(true);

        } catch (error) {
            console.log(error.message);
            navigate('/error');
        }
    }

    // This function will help to request, resend, save the things
    let verifyOTP = function (e) {
        e.preventDefault();

        if (state.resend === 0) { // When we have OTP button in request mode, execute the below code

            if (!phoneVerified) {
                fetch(`${apiURL}/api/signUp`, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json',
                        "key": 'phone'
                    },
                    body: JSON.stringify({ phoneNumber: input_user.current.value }),
                    credentials: "include"
                }).then(res => {
                    if (res.status === 500) {
                        throw new Error('Error occured while verifying OTP');
                    } else {
                        return res
                    }
                }).then(res => res.json())
                    .then(res => {
                        if (res) {
                            // setPhnExistModal(true);
                            setResend(false);
                            alert('Phone number is already registered');
                            navigate('/login');
                            return;
                        } else {
                            requestOtp(e);
                        }
                    }).catch(error => {
                        navigate('/error');
                        console.log(error.message);
                    })
            } else if (!mailVerified) {
                fetch(`${apiURL}/api/signUp`, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json',
                        "key": 'mail'
                    },
                    body: JSON.stringify({ mailId: input_user.current.value }),
                    credentials: "include"
                }).then(res => {
                    if (res.status === 500) {
                        throw new Error('Error occured while verifying OTP');
                    } else {
                        return res
                    }
                }).then(res => res.json())
                    .then(res => {
                        if (res) {
                            // setPhnExistModal(true);
                            setResend(false);
                            alert('Mail id is already registered');
                            navigate('/login');
                            return;
                        }
                        else {
                            // requestOtp(e);
                            setMailVerified(true);
                        }
                    }).catch(error => {
                        navigate('/error');
                        console.log(error.message);
                    })
            }
        }
        else if (state.resend === 2) { // When OTP button shows "continue", when OTP is 4 digit

            if (!phoneVerified) {

                setvalidateDisabled(true);
                let otp = input_otp.current.value;
                confirmation.confirm(otp).then(() => {
                    // Set phone verifincation true
                    setPhoneVerified(true);
                    // Title gets updated to mailId and request msg will be displayed in next phase
                    setState((values) => {
                        return { ...values, title: values.title + 1, otp: 0, resend: 0 } // OTP = 0 is otp button will hide, resend = 0 means Request OTP will show
                    })
                    // Save the phone number after verification
                    SetNumber(Number(input_user.current.value));
                    // Open input userbox for user input
                    input_user.current.disabled = false;
                    input_otp.current.value = null; // Clear Previous input OTP
                    input_otp.current.style.display = 'none'; // Hide OTP input box
                    input_user.current.value = null; // Clear user's previous input
                    setResend(false);
                    setvalidateDisabled(false);
                }).catch(() => {
                    setvalidateDisabled(false);
                    setshowIncorrectOTPMsg(true);
                })

            }
            //  else {

            //     // Set Mail verifincation true
            //     setMailVerified(true);
            //     // Title gets updated to mailId and request msg will be displayed in next phase
            //     setState((values) => {
            //         return { ...values, title: values.title + 1, otp: 0, resend: 3 } // OTP = 0 is otp button will hide, resend = 0 means Request OTP will show
            //     })
            //     // Save the mail id after verification
            //     SetmailId(input_user.current.value);
            //     // Open input userbox for user input
            //     input_user.current.disabled = false;
            //     input_otp.current.value = null; // Clear Previous input OTP
            //     input_otp.current.style.display = 'none'; // Hide OTP input box
            //     input_user.current.value = null; // Clear user's previous input
            //     setResend(false);
            // }
        }
        else if (state.resend === 3) { // when the button msg is "Save"
            if (state.title === 1) { // Title 2 means fname
                SetmailId(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to Last name
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 2) { // Title 2 means fname
                setFname(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to Last name
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 3) {
                setLname(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to store
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 4) {
                setstore(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to address
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 5) {
                setAddress(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to pin
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 6) {
                setPin(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to b_address
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 7) {
                setb_address(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to b_address_pin
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 8) {
                setb_address_pin(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to city
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 9) {
                setb_city(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to state
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 10) {
                setb_state(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to gstin
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 11) {
                setgstin(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to backAccNo
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 12) {
                setbankAccNo(input_user.current.value);
                input_user.current.value = null; // Clear previous user input before going to payee name
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 13) {
                setpayeeName(input_user.current.value);
                input_user.current.value = null; // Clear previous user input
                setState((values) => {
                    return { ...values, title: values.title + 1, otp: 0 } // OTP = 0 is otp button will hide, resend = 1 means "Save" will show
                });
            } else if (state.title === 14) { // Title 14 means "IFSC"
                fetch(`${apiURL}/api/signUp`, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'Application/json',
                        "key": 'login'
                    },
                    body: JSON.stringify({
                        phone: phone,
                        mail: mail,
                        fname: fname,
                        lname: lname,
                        store: store,
                        address: address,
                        pin: pin,
                        b_address: b_address,
                        b_address_pin: b_address_pin,
                        b_city: b_city,
                        b_state: b_state,
                        gstin: gstin,
                        bankAccNo: bankAccNo,
                        payeeName: payeeName,
                        ifsc: input_user.current.value
                    }),
                    credentials: "include"
                }).then(res => {
                    if (res.status === 500) {
                        throw new Error('Error occured while verifying OTP');
                    } else {
                        return res
                    }
                }).then(res => {
                    if (res.ok) {
                        fetch(`${apiURL}/authenticate`, {
                            method: 'POST',
                            headers: {
                                'Content-type': 'Application/json'
                            },
                            body: JSON.stringify({
                                phoneNumber: phone
                            }),
                            credentials: "include"
                        }).then(res => {
                            if (res.status === 500) {
                                throw new Error('Error occured while authentication');
                            } else {
                                return res
                            }
                        }).then(res => res.json())
                            .then(res => {
                                loginStatus();
                                username(res.fname);
                                navigate('/dashboard');
                            }).catch(error => {
                                console.log(error);
                            })
                    } else {
                        navigate('/error');
                    }
                }).catch(error => {
                    navigate('/error');
                    console.log(error.message);
                })
            }
        }
    }


    function navigateLogin() {
        navigate('/');
    }

    useEffect(() => {
        input_otp.current.style.display = 'none';
    }, []);

    return (
        <>
            {/* <Modal
                // {...props}
                // size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={incorrectOTPModal || phnExistModal || mailExistModal || errorOccModal} onHide={() => {
                    if (incorrectOTPModal) {
                        setIncorrectOTPModal(false);
                    } else if (phnExistModal) {
                        setPhnExistModal(false);
                    } else if (mailExistModal) {
                        setMailExistModal(false);
                    } else if (errorOccModal) {
                        setErrorOccModal(false);
                    }
                }}
                backdrop={true}>
                <Modal.Header>
                    <Modal.Title>Charui</Modal.Title>
                </Modal.Header>
                <Modal.Body>{incorrectOTPModal ? 'Incorrect OTP' : phnExistModal ? 'Phone number is already registered' :
                    mailExistModal ? 'Mail is is already registered, try with different mail ID' :
                        errorOccModal ? 'Issue occured! Please try afetr sometime' : ''}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        if (incorrectOTPModal) {
                            setIncorrectOTPModal(false);
                        } else if (phnExistModal) {
                            setPhnExistModal(false);
                        } else if (mailExistModal) {
                            setMailExistModal(false);
                        } else if (errorOccModal) {
                            setErrorOccModal(false);
                        }
                    }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal> */}
            <div className={`${styles.mainDiv}`}>
                <div className={`${styles.rightDiv}`}>
                    <span className={`${styles.loginSignupHeading}`}>NEW SELLER SIGN UP</span>
                    <form className={`${styles.form}`}>
                        <div className={`${styles.formDiv}`} >
                            <label className={`${styles.EnterphonNo}`}>ENTER {' '} {state.title === 0 ? 'PHONE NUMBER' : state.title === 1 ? 'EMAIL ID' : state.title === 2 ? 'FIRST NAME' : state.title === 3 ? 'LAST NAME' :
                                state.title === 4 ? 'Store name' : state.title === 5 ? 'Home address' : state.title === 6 ? 'Home address pin code' :
                                    state.title === 7 ? 'Business address' : state.title === 8 ? 'Business address pin code' : state.title === 9 ? 'City' :
                                        state.title === 10 ? 'State' :
                                            state.title === 11 ? 'GSTIN no' : state.title === 12 ? 'Bank account number' : state.title === 13 ? 'Account holder name' :
                                                state.title === 14 ? 'Bank IFSC code' : ''}</label>

                            <div className={`${styles.OTPdiv}`}>
                                <input type="text" ref={input_user} onChange={inputCheck} className={`${styles.baseInput}`} />

                                <input id='otp' type="text" ref={input_otp} maxLength={6}
                                    onChange={() => setshowIncorrectOTPMsg(false)}
                                    className={`${styles.userInput}`} placeholder='Enter OTP here' />

                                <div className={`${styles.placeHolderDiv}`}></div>

                                <input type="button" style={state.otp === 1 ? { display: 'block' }
                                    : { display: 'none' }} value={state.resend === 0 ? 'Request OTP' : state.resend === 1 ? 'Resend OTP'
                                        : state.resend === 2 ? 'Continue' : 'Save'} onClick={verifyOTP} className={`${styles.resendBtn}`} 
                                        disabled = {validateDisabled}/>

                                <div style={showResend ? { visibility: 'visible' } : { visibility: 'hidden' }}>
                                    <p id='incorrectOTP' className={`${styles.incorrectOTPMsg}`}
                                        style={showIncorrectOTPMsg ? { visibility: 'visible' } : { visibility: 'hidden' }}>Incorrect OTP</p>
                                    <span style={{ fontSize: '12px' }}>Didn't receive OTP? resend in {renendGap} seconds</span>
                                    <button disabled={resendDisable} onClick={e => requestOtp(e)}
                                        className={`${styles.resendBtnLogin}`}>RESEND</button>
                                </div>

                            </div>
                        </div>
                    </form>
                    <div style={showSpinner ? { display: 'block', alignSelf: 'center' } : { display: 'none' }}>
                        <Spinner animation="grow" style={{ width: "30px", height: "30px" }} />
                    </div>
                    <div className={`${styles.notHave}`} style={{ marginTop: '50px' }}>
                        <span className={`${styles.dontAccont}`}>
                            ALREADY HAVE AN ACCOUNT!
                        </span>
                        <button className={`${styles.signRoute}`} onClick={navigateLogin}>Click here</button>
                    </div>
                </div>
                <div id="recaptcha-container"></div>
            </div>
        </>
    )
};